import { gql } from 'apollo-angular';

export const addressFragment = gql`
fragment AddressFields on Address
{
    street
    city
    region
    regionCode
    countryCode
    postalCode
    latitude
    longitude
    primary
}`;
